module.exports = __webpack_public_path__ + "static/media/je.35c3c091.svg";